<template>
  <div>
    <template v-if="!refRevenue">
        <div v-if="refData">
            <div class="sa-row">
              <div class="sa-col-xs12 sa-col-sm7 sa-col-md9 sa-col-lg6">
                <h5 class="sa-mb15">Referral Details</h5>
              </div>
              <div class="sa-col-xs12 sa-col-sm5 sa-col-md3 sa-col-lg3 sa-report-month">
                <div class="sa-form-group">
                <!-- <i class="icon-down-arrow sa-form-icon sa-picker-icon"></i> -->
                <month-picker-input :min-date="minDate" :default-month="duration_month" :default-year="duration_year" @input="showDate" ></month-picker-input>
                </div>
              </div>
               <div class="sa-col-xs12 sa-col-sm6 sa-col-md3 sa-col-lg3">
                <div class="sa-form-group">
                  <i class="icon-down-arrow sa-form-icon"></i>
                  <select class="sa-form-control" @change="refDashboard" v-model="product_type">
                      <option v-for="(name, value, index) of products" :key="index" :value="value">{{ name }}</option>
                    </select>
                </div>
              </div>
            </div>
            <div class="sa-appoint-list">
              <span
                ><input
                  type="radio"
                  v-model="pType"
                  id="video1"
                  name="reports"
                  @change="refDashboard"
                  value="all"
                  checked
                /><label for="video1">All</label></span
              >
              <span
                ><input
                  type="radio"
                  v-model="pType"
                  id="video2"
                  name="reports"
                  @change="refDashboard"
                  value="cash"
                /><label for="video2">Cash</label></span
              >
              <span
                ><input
                  type="radio"
                  v-model="pType"
                  id="video3"
                  name="reports"
                  @change="refDashboard"
                  value="insurance"
                /><label for="video3">Insurance</label></span
              >
            </div>
            <apexchart
              type="line"
              class="line-graph"
              height="180"
              :options="chartOptions"
              :series="series"
            ></apexchart>
            <div class="sa-row sa-ref-btn sa-mt20">
              <div class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg5">
                <div
                  class="
                    sa-card sa-card-border sa-card-noshadow sa-d-f-sbetween
                  "
                >                                                                                                                         
                  <span> Total Completed referrals</span><strong>{{refData.total_completed}}</strong>
                </div>
              </div>
              </div>
              <refferal-details ></refferal-details>
          </div>
    </template>
    <div class="sa-dialog-white" v-if="loading">
      <img
        src="../../assets/img/loader.svg"
        alt="loader"
        class="sa-loader sa-loader-top"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { MonthPickerInput } from "vue-month-picker"
import RefferalDetails from "./RefferalDetails.vue";
import { oh_url } from "../../../config/endpoints"
import moment from "moment";
export default {
  components: {
    apexchart: VueApexCharts,
    RefferalDetails,
    MonthPickerInput
  },

  data() {
    return {
      minDate: null,
      duration_month: null,
      duration_year: null,
      loading: false,
      refData: null,
      pType: 'all',
      product_type: "ST01",
      products: {
        "ST01": "Home visit Doctor",
        "ST11": "Telemedicine",
        "ST02": "Physiotherapist",
        "ST03": "Nurse",
        "ST031": "Radiology",
        "ST032": "Vitamin IV Drips",
        "ST033": "Vaccination",
        "ST034": "Hemodialysis",
        "ST035": "Caregiver",
        "ST036": "Covid Vaccination",
        "ST04": "Lab Technician",
        "ST041": "Covid PCR"
      },
      refRevenue: false,
      series: [
        {
          name: "SAR",
          data: []
        },
      ],
      chartOptions: {
        // legend: {
        //   formatter: {}
        // },
        chart: {
          width: "100%",
          parentHeightOffset: 0,
          type: "line",
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 1,
          curve: "smooth",
          lineCap: "butt",
          dashArray: 0,
        },
        grid: {
          show: true,
          strokeDashArray: 3,
          xaxis: {
            lines: {
              show: false,
            },
          },
          yaxis: {
            show: true,

            lines: {
              show: true,
            },
          },
        },
        tooltip: {
          enabled: true,
          x: {
            show: false,
          },
          y: {
            formatter: {}
            // formatter: function(
            //   value,
            //   { series, seriesIndex, dataPointIndex, w }
            // ) {
            //   return value;
            // }
          },
          marker: {
            show: false,
          },
        },
        xaxis: {
          type: "category",
          categories: [],
          axisBorder: {
            show: false,
            color: "#ECF1FB",
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          // max: 0,
          show: true,
          axisBorder: {
            show: false,
            color: "#ECF1FB",
          },

          labels: {
            formatter: function (value) {
              return parseInt(value);
            },
          },
        },
      },
    };
  },
  mounted() {
    let mdate = new Date()
    this.minDate = new Date('2021-12-01')
    this.duration_month = mdate.getMonth()+1
    this.duration_year = mdate.getFullYear()
    this.refDashboard()
  },
  methods: {
    showDate (date) {
      this.duration_month = date.monthIndex
      this.duration_year = date.year
      this.chartOptions = {
        xaxis: {
          type: "category",
          categories: [],
          axisBorder: {
            show: false,
            color: "#ECF1FB",
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            show: false,
          },
          tooltip: {
            enabled: false,
          }
        }
      }
      this.refDashboard()
    },
    refDashboard() {
      let _self = this
      _self.loading = true
       _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/referrals/dashboard`,
          body: {
            duration_month: this.duration_month,
            duration_year: this.duration_year,
            product_type: this.product_type,
            payment_type: this.pType
        }
        })
        .then((response) => {
          if(response && response.status == 1000){
            _self.loading = false
            _self.refData = response
            let chartOption = JSON.parse(JSON.stringify(_self.chartOptions))
            chartOption.xaxis.categories = response.graph_data.x
            _self.chartOptions = JSON.parse(JSON.stringify(chartOption))
            _self.series[0].data = response.graph_data.y
            _self.chartOptions.tooltip.y.formatter = function(seriesName, opts) {
              return response.graph_data.tooltip[opts.dataPointIndex]
            }
          }
        })
    }
  }
};
</script>
<style scoped>

[type="radio"]:not(:checked) + label:before, [type="radio"]:checked + label:before{z-index: 0;}
</style>
